export const userApi = {
  sendCode: '/rdp/console/api/v1/verify/sendcode',
  sendCodeInLoginState: '/rdp/console/api/v1/verify/sendcodeinloginstate',
  register: '/register',
  login: '/login',
  logout: '/logout',
  getPublicKey: '/getPublicKey',
  getGlobalSettings: '/global_settings',
  listOrg: '/list_org',
  checkSupplement: '/check_supplement',
  resetPwdUnLogin: '/resetpwdunlogin',
  resetPwdWithOriginPwd: '/rdp/console/api/v1/user/resetPwdWithOriginPwd',
  updateUserEmailWithPwd: '/rdp/console/api/v1/user/updateUserEmailWithPwd',
  updateUserPhoneWithPwd: '/rdp/console/api/v1/user/updateUserPhoneWithPwd',
  resetSubAccountPwd: '/rdp/console/api/v1/user/resetSubAccountPwd',
  dmGlobalSettings: '/clouddm/console/api/v1/dm_global_settings',
  watermark: '/rdp/console/api/v1/user/waterMark',
  getUserInfo: '/rdp/console/api/v1/user/queryLoginUser',
  resetPassword: '/rdp/console/api/v1/user/manager/resetpasswd',
  getSubAccountList: '/rdp/console/api/v1/user/manager/listsubaccounts',
  updateSubAccount: '/rdp/console/api/v1/user/manager/updatesubaccount',
  addSubAccount: '/rdp/console/api/v1/user/manager/addsubaccount',
  deleteSubAccount: '/rdp/console/api/v1/user/manager/deletesubaccount',
  updateUserRole: '/rdp/console/api/v1/user/manager/updateuserrole',
  stopSubAccount: '/rdp/console/api/v1/user/manager/updateaccountability',
  checkSubAccountDuplicate: '/rdp/console/api/v1/user/manager/checksubaccountduplicate',
  getResourceSummary: '/rdp/console/api/v1/user/resourceSummary',
  resetOpPwd: '/rdp/console/api/v1/user/resetOpPasswd',
  getDbOpAudits: '/clouddm/console/api/v1/user/dbopaudits', // 数据源操作记录
  updatealiyunaksk: '/rdp/console/api/v1/user/updateAliyunAkSk',
  verifyOpPwd: '/rdp/console/api/v1/user/opPasswdVerify',
  cleanaliyunaksk: '/rdp/console/api/v1/user/cleanaliyunaksk',
  listMyAuth: '/rdp/console/api/v1/user/listMyAuth',
  listRules: '/rdp/console/api/v1/user/listRules',
  getCurrUserConfigs: '/rdp/console/api/v1/user/config/getcurruserconfigs',
  updateUserConfigs: '/rdp/console/api/v1/user/config/upsertuserconfigs',
  queryPrimaryUser: '/rdp/console/api/v1/user/queryPrimaryUser'
};
